<script lang="ts">
  import Attachments from "./Attachments.svelte";
  import { Detail, Detail2, Detail3, GoodMorning, Hello } from "../../../../utils/Constant/Constant";
</script>
<div class="email-wrapper">
    <form class="emailread-group">
        <div class="read-group">
            <p>{Hello}</p>
            <p>{GoodMorning}</p>
        </div>
        <div class="read-group">
            <h5>{Detail}</h5>
            <p>{Detail2} </p>
            <p class="m-t-10">{Detail3}</p>
        </div>
    </form>
    <Attachments />
</div>